import { render, staticRenderFns } from "./courierlist.vue?vue&type=template&id=01817714&scoped=true&"
import script from "./courierlist.vue?vue&type=script&lang=js&"
export * from "./courierlist.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./courierlist.vue?vue&type=style&index=1&id=01817714&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01817714",
  null
  
)

export default component.exports